import { BaseService } from './base-service';

class FieldAggregationService extends BaseService {
  /**
   * 更新视图字段聚合类型并获取列表页字段聚合结果
   * @param {Object} data
   * @param {number} data.id viewId
   * @param {number} data.entity entityId
   * @param {number} data.sceneId sceneId
   * @param {number} data.sceneType sceneType
   * @param {Array} data.conditions 筛选
   * @param {Object} data.searchFields 搜索
   * @param {Object} data.aggregation
   * @param {string} data.aggregation.fieldKey 统计字段
   * @param {string} data.aggregation.type 聚合类型
   * @returns {*}
   */
  updateAndGetListPageAggregation(data) {
    return this.request({
      method: 'post',
      url: `/field/aggregation/listPage/single`,
      data
    });
  }

  /**
   * 获取列表页字段聚合结果
   * @param {Object} data
   * @param {number} data.id viewId
   * @param {number} data.entity entityId
   * @param {number} data.sceneId sceneId
   * @param {number} data.sceneType sceneType
   * @param {Array} data.conditions 筛选
   * @param {Object} data.searchFields 搜索
   * @returns {*}
   */
  getListPageAggregation(data) {
    return this.request({
      method: 'post',
      url: `/field/aggregation/listPage/all`,
      data
    });
  }

  /**
   * 更新表格字段聚合类型并获取表格字段聚合结果
   * @param {Object} data
   * @param {number} data.itselfTableEntity
   * @param {number} data.tableEntity
   * @param {number} data.layoutId
   * @param {number} data.layoutConfigId
   * @param {Array} data.businessId
   * @param {Object} data.aggregation
   * @param {string} data.aggregation.fieldKey 统计字段
   * @param {string} data.aggregation.type 聚合类型
   * @returns {*}
   */
  updateAndGetTableAggregation(data) {
    return this.request({
      method: 'post',
      url: `/field/aggregation/table/single`,
      data
    });
  }

  /**
   * 获取列表页字段聚合结果
   * @param {Object} data
   * @param {number} data.itselfTableEntity
   * @param {number} data.tableEntity
   * @param {number} data.layoutId
   * @param {number} data.layoutConfigId
   * @param {Array} data.businessId
   * @returns {*}
   */
  getTableAggregation(data, apiIndex) {
    return this.request({
      method: 'post',
      url: `/field/aggregation/table/all`,
      data,
      params: { apiIndex }
    });
  }
}

export const fieldAggregationService = new FieldAggregationService();
